module.exports = __webpack_public_path__ + "static/p3-94bc09f9e4fb2e60ec51f918500c6976.jpg";